import { useMonthFormat } from '@gogame/intl-ts';
import { useScreenMessage } from '@gogame/screens';

import { restoreMarketingPlan } from '../sources/marketingPlanning';

export const useRestoreMarketingPlan = () => {
  const { showSuccessMessage, showErrorMessage } = useScreenMessage();
  const monthYearFormat = useMonthFormat();

  return ({ year, month, version, viewVersion }) => {
    const comment = `Restored from ${viewVersion} to ${monthYearFormat({
      year,
      month,
    })}`;
    return restoreMarketingPlan({ year, month, version, comment })
      .then((response) => {
        showSuccessMessage(
          `Plan was restored according to version ${viewVersion} as ${response.viewVersion}`
        );
        return response;
      })
      .catch((e) => {
        showErrorMessage(e.message);
        return Promise.reject(e);
      });
  };
};
